import { render, staticRenderFns } from "./ys.vue?vue&type=template&id=8ada3854&scoped=true"
import script from "./ys.vue?vue&type=script&lang=js"
export * from "./ys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ada3854",
  null
  
)

export default component.exports